import React from "react";
import {OverlayTrigger, Tooltip} from "react-bootstrap";
import {AMPEL_FARBEN, AMPEL_LABEL, AMPEL_LEGENDE} from "./AmpelSelect.jsx";

// #21 (zweite Sichtprüfung): der interne Verweis "PLAN.md Abschnitt 1b" aus
// AmpelSelect.jsx gehört nicht vor Thorstens Augen - hier bewusst eigener,
// neutraler Text statt des importierten Hinweises.
const LESART_HINWEIS = "Die genaue Lesart stimmen wir mit dem Einkauf ab.";
import {TOOLTIP_POPPER_CONFIG} from "./tooltipConfig.js";

/** Kleines Farbfeld der Legende - "ohne Farbe" bekommt ein neutrales, gestricheltes Feld statt einer erfundenen Farbe. */
function LegendenChip({farbe}) {
    if (farbe === null) {
        return (
            <span
                aria-hidden="true"
                className="d-inline-block rounded-1 flex-shrink-0"
                style={{width: 16, height: 16, border: "1px dashed #adb5bd", backgroundColor: "#fff"}}
            />
        );
    }
    return (
        <span
            aria-hidden="true"
            className="d-inline-block rounded-1 flex-shrink-0"
            style={{width: 16, height: 16, border: "1px solid rgba(0,0,0,.25)", backgroundColor: AMPEL_FARBEN[farbe]}}
        />
    );
}

/**
 * Legende der Ampel in Oskars Farben (AP7 B, PLAN.md Abschnitt 1b) - je
 * Eintrag ein Erklär-Tooltip; bei "rot" und "ohne Farbe" zusätzlich der
 * Hinweis, dass die genaue Lesart noch mit Oskar geklärt wird. Der
 * gestrichelte Rand einer errechneten Zelle wird als eigener Eintrag
 * erläutert, damit die Bedeutung nicht erraten werden muss.
 */
export default function LieferplanLegende() {
    return (
        <div className="d-flex flex-wrap align-items-center gap-3 mb-2 small">
            {AMPEL_LEGENDE.map((eintrag) => (
                <OverlayTrigger flip popperConfig={TOOLTIP_POPPER_CONFIG}
                    key={eintrag.farbe || "ohne-farbe"}
                    placement="top"
                    overlay={
                        <Tooltip id={`legende-${eintrag.farbe || "ohne-farbe"}`}>
                            {eintrag.text}
                            {eintrag.klaerung ? <div className="mt-1 fst-italic">{LESART_HINWEIS}</div> : null}
                        </Tooltip>
                    }
                >
                    <span className="d-inline-flex align-items-center gap-1" tabIndex={0}>
                        <LegendenChip farbe={eintrag.farbe} />
                        {eintrag.farbe ? AMPEL_LABEL[eintrag.farbe] : "Ohne Farbe"}
                    </span>
                </OverlayTrigger>
            ))}
            <OverlayTrigger flip popperConfig={TOOLTIP_POPPER_CONFIG}
                placement="top"
                overlay={
                    <Tooltip id="legende-errechnet">
                        Cosmos-typischerweise ohne gespeicherte Ampel: Die Tabelle errechnet dann eine Ampel nach der
                        Rückfallformel (Zusage deckt Wunsch termingerecht → grün, keine Zusage → rot, Ist erreicht
                        Wunsch → weiß, sonst gelb) und kennzeichnet sie mit gestricheltem Rand statt durchgezogenem.
                    </Tooltip>
                }
            >
                <span className="d-inline-flex align-items-center gap-1 text-muted" tabIndex={0}>
                    <span
                        aria-hidden="true"
                        className="d-inline-block rounded-1 flex-shrink-0"
                        style={{width: 16, height: 16, border: "2px dashed #868e96"}}
                    />
                    Gestrichelt = errechnet
                </span>
            </OverlayTrigger>
        </div>
    );
}
